import axios from '../axios'
import qs from "qs";

function service(endpoint) {

    function check(id, data = {}) {
        return axios.get(`${endpoint}/${id}/check`, { params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    return {
        check
    }
}

export default service
